module.exports = __webpack_public_path__ + "static/img/1.d3c7189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/1.png
// module id = yyge
// module chunks = 1